import { axios } from '@complispace/cs-design-system';

const baseURL = process.env.CONTENT_ENGINE_URL;
const contextBaseUrl = `${baseURL}/app/contexts`;

const context = {
  // GET /app/contexts
  async getContext() {
    return axios.get(`${contextBaseUrl}`);
  },

  async getChildContext(key) {
    return axios.get(`${contextBaseUrl}/children/keys/${key}`);
  },

  // PUT /app/contexts/keys/{key}
  async updateContextItem(key, details) {
    return axios.put(`${contextBaseUrl}/keys/${key}`, details);
  },

  async updateChildContextItem(key, payload) {
    return axios.put(`${contextBaseUrl}/children/keys/${key}`, payload);
  },

  // GET /app/contexts/keys/{key}/pages
  async getPageDetailsForContextKey(key) {
    return axios.get(`${contextBaseUrl}/keys/${key}/pages`);
  }
};

export default context;
